import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { tr } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E6EAEC] p-6">
      <div className="max-w-md w-full border border-[#e4e4e7] p-10 text-center">
        <XCircle className="w-14 h-14 mx-auto text-[#71717a] mb-4" />
        <h1 className="font-display text-2xl mb-2">{tr("Pagamento annullato", "Payment cancelled")}</h1>
        <p className="text-sm text-[#71717a] mb-6">{tr("Nessun addebito effettuato. Puoi riprovare in qualsiasi momento.", "No charge was made. You can try again at any time.")}</p>
        <Link to="/" className="inline-block aurora-gradient text-white px-6 py-2.5 text-sm font-medium">{tr("Torna alla home", "Back to home")}</Link>
      </div>
    </div>
  );
}
